import { useRef } from 'react'
import { useQuery } from 'react-query'
import { captureUTM } from '../apiModules/captureUtm'

export const useCaptureUTM = urlParams => {
  const captured = useRef(false)

  useQuery(['captureUtm'], () => captureUTM(urlParams), {
    onSuccess: () => {
      captured.current = true
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !captured.current,
    retry: false,
  })
}
